module.exports = __webpack_public_path__ + "static/img/0544_6.77aace8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0544_6.jpg
// module id = 67Tw
// module chunks = 1